import React from 'react';
import {SaveConflict} from '../stores/ReportEditorStore';
import {observer} from 'mobx-react';
import Modal from '../../Modal';
import {I18n, TProvider} from '../../i18n/i18n';
import Store from '../../stores/store';
import {classes, stylesheet} from 'typestyle';
import {blueButtonClassName} from '../../styles/style';
import {RedColor} from '../../styles/colors';
import {inject} from '../../inject';

interface SaveConflictModalProps {
    renameAndSaveAsNewAfterConflict: (reportName: string) => void;
    reportName: string;
    store: Store;
    setSaveConflict: (saveConflict?: SaveConflict) => void;
    saveConflict: SaveConflict;
    saveReport: (force?: boolean) => void;
    toRenameView: () => void;
}

@observer
class SaveConflictModal extends React.Component<SaveConflictModalProps, {renameReportText: string}> {
    constructor(props) {
        super(props);
        this.state = {
            renameReportText: props.reportName,
        };
    }

    private getHeader = (): React.ReactNode => {
        return this.props.saveConflict.showRenameDialog ? <I18n i18nKey="report:renameAndSaveAsNew" /> : <I18n i18nKey="report:saveConflict" />;
    };

    private handleReportNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            renameReportText: e.currentTarget.value,
        });
    };

    private getBody = (): React.ReactNode => {
        return this.props.saveConflict.showRenameDialog ? (
            <div>
                <div className={conflictCss.title}>
                    <I18n i18nKey="report:reportName" />
                </div>
                <TProvider>
                    {(t) => (
                        <input
                            className={conflictCss.nameField}
                            value={this.state.renameReportText}
                            placeholder={t('report:reportName')}
                            onChange={this.handleReportNameChange}
                            type="text"
                        />
                    )}
                </TProvider>
            </div>
        ) : (
            <div className={conflictCss.conflictMessage}>
                <I18n i18nKey="report:saveConflictExplanation" />
            </div>
        );
    };

    private getFooter = (): React.ReactNode => {
        return this.props.saveConflict.showRenameDialog ? (
            <div>
                <button
                    className={classes(
                        blueButtonClassName,
                        this.state.renameReportText === this.props.reportName ? conflictCss.disabledButton : undefined
                    )}
                    disabled={this.state.renameReportText === this.props.reportName}
                    onClick={() => this.props.renameAndSaveAsNewAfterConflict(this.state.renameReportText)}>
                    <I18n i18nKey="data.save" />
                </button>
            </div>
        ) : (
            <div>
                <button className={blueButtonClassName} onClick={this.props.toRenameView}>
                    <I18n i18nKey="report:renameAndSaveAsNew" />
                </button>
                <button className={classes(blueButtonClassName, conflictCss.overwriteButton)} onClick={() => this.props.saveReport(true)}>
                    <I18n i18nKey="report:overwriteOld" />
                </button>
            </div>
        );
    };

    public render = () => {
        return (
            <Modal
                onModalClose={() => this.props.setSaveConflict(undefined)}
                modalHeader={<div>{this.getHeader()}</div>}
                modalBody={this.getBody()}
                modalFooter={this.getFooter()}
                store={this.props.store}
            />
        );
    };
}

export default inject('store')(SaveConflictModal);

const conflictCss = stylesheet({
    conflictMessage: {
        textAlign: 'center',
    },
    overwriteButton: {
        marginLeft: 15,
        backgroundColor: RedColor,
    },
    nameField: {
        width: '100%',
    },
    title: {
        fontWeight: 'bold',
        fontSize: 12,
        marginBottom: 5,
    },
    disabledButton: {
        opacity: 0.5,
    },
});



// WEBPACK FOOTER //
// ./src/report/views/SaveConflictModal.tsx